export const AUTH_TOKEN = '/get-auth-token';
export const USER_DEVICES = '/user/devices';
export const ASSETS = '/assets';
export const REQUEST_STATUS = '/asset/{0}/device/request-status/{1}';
export const FIRMWARE_AVAILABILITY = '/asset/{0}/device/firmwareUpdateAvailability';
export const SUBSCRIPTION = '/asset/{0}/subscription';
export const SYNCHRONIZE = '/asset/{0}/device/actions/synchronize';
export const UPDATE_SETTING = '/asset/{0}/device/actions/updateSetting';
export const REGISTRATION_STATUS = '/asset/{0}/device/actions/registration-status';
export const CONNECTIVITY_STATUS = '/asset/{0}/device/connectivity/status';
export const EXPERIENCE_INFERENCE_GENERATE = '/asset/{0}/device/actions/device-analytics/TipsTricks';
export const EXPERIENCE_INFERENCE_GET = '/asset/{0}/device/inference/TipsTricks';
